import { memo, useContext } from "react";
import { IbanXSBanksRecipientsPivot } from "ui/forms/OpenBanking";
import { IbanXSBanksRecipientsPivotFormContext } from "./IbanXSBanksRecipientsPivotFormContext";

type Props = {
    readonly initialValues: Pick<
    IbanXSBanksRecipientsPivot.IbanXSBanksRecipientsPivotForm['initialValues'],
        | 'bankId'
        | 'recipientId'
    >;
};

const IbanXSBanksRecipientsPivotForm = ({
    initialValues
}: Props) => (
    <IbanXSBanksRecipientsPivot.Form
        {...useContext(IbanXSBanksRecipientsPivotFormContext)}
        initialValues={IbanXSBanksRecipientsPivot.getInitialValues(initialValues)}
    />
);

export default memo(IbanXSBanksRecipientsPivotForm);
